import { appCopy } from '../../app-ui/baseline';
export const resultCategories = [
  { route: 'reviews', bucket: 'albums', label: 'common.albums' },
  { route: 'artists', bucket: 'artists', label: 'common.artists' },
  { route: 'lists', bucket: 'playlists', label: 'common.playlists' },
];
export const displayResultCount = (count) => (count >= 25 ? '25+' : String(count));
export function resultCategoryLabel(category, locale) {
  return appCopy(
    locale,
    resultCategories.find((item) => item.route === (category === 'mixes' ? 'lists' : category))
      ?.label || 'common.albums',
  );
}
export function withoutAdvertisedAlbums(items, campaigns, allowIdFallback = false) {
  const advertised = new Set(campaigns.flatMap((c) => (c.albums || []).map((a) => Number(a.id))));
  return items.filter((item) => {
    const rawId = allowIdFallback ? (item.albumId ?? item.id) : item.albumId;
    if (rawId == null) return true;
    const id = Number(rawId);
    return !Number.isFinite(id) || !advertised.has(id);
  });
}
// SearchCategoryScreen's own placement contract differs from the generic rail planner:
// later repeats beyond the original item count must not collapse into stacked tail ads.
export function searchResultEntries(items, campaigns, category) {
  if (!items.length || !campaigns.length) return items.map((item) => ({ kind: 'organic', item }));
  const planned = campaigns
    .flatMap((campaign) => {
      const placement = campaign.placements[0];
      let at = Math.max(0, placement?.startAfterOrganic ?? items.length);
      const slots = [];
      for (
        let occurrence = 0;
        occurrence < Math.min(placement?.maxPerScreen ?? 1, 3);
        occurrence++
      ) {
        if (occurrence > 0 && at > items.length) break;
        slots.push({ at, campaign, occurrence });
        if (!placement?.repeatEvery) break;
        at += Math.max(placement.repeatEvery, 6);
      }
      return slots;
    })
    .sort(
      (a, b) =>
        a.at - b.at ||
        (a.campaign.placements[0]?.position ?? 0) - (b.campaign.placements[0]?.position ?? 0),
    );
  const shown = new Set(planned.map((p) => p.campaign.id));
  const organic =
    category === 'reviews'
      ? withoutAdvertisedAlbums(
          items,
          campaigns.filter((c) => shown.has(c.id)),
          true,
        )
      : items;
  const entries = [];
  for (let at = 0; at <= organic.length; at++) {
    planned
      .filter((p) => Math.min(p.at, organic.length) === at)
      .forEach((p) => entries.push({ kind: 'sponsored', ...p }));
    if (at < organic.length) entries.push({ kind: 'organic', item: organic[at] });
  }
  return entries;
}
